module.exports = __webpack_public_path__ + "static/img/manage-info.c08a7fc2.svg";